import { render, staticRenderFns } from "./MetaConnectionInfoDrawer.vue?vue&type=template&id=08b38c66&scoped=true&"
import script from "./MetaConnectionInfoDrawer.vue?vue&type=script&lang=js&"
export * from "./MetaConnectionInfoDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MetaConnectionInfoDrawer.vue?vue&type=style&index=0&id=08b38c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b38c66",
  null
  
)

export default component.exports